import React from 'react';
import ShowArticleCostsButtonRowProperties from './ShowArticleCostsButtonRowProperties';
import ViewSmall from '../../../../ui_components/MediaView/ViewSmall';
import ShowArticleCostsButtonRowSmall from './ShowArticleCostsButtonRowSmall';
import ViewMedium from '../../../../ui_components/MediaView/ViewMedium';
import ViewLarge from '../../../../ui_components/MediaView/ViewLarge';
import ShowArticleCostsButtonRowMedium from './ShowArticleCostsButtonRowMedium';


const ShowArticleCostsButtonRow: React.FC<ShowArticleCostsButtonRowProperties> = ({
                                                    articleId,
                                                    prices,
                                                    articles: products
                                                }) => {
    return (
        <>
            <ViewSmall>
                <ShowArticleCostsButtonRowSmall 
                    articleId={articleId}
                    prices={prices}
                    articles={products}
                />
            </ViewSmall>
            <ViewMedium>
                <ShowArticleCostsButtonRowMedium 
                    articleId={articleId}
                    prices={prices}
                    articles={products}
                />
            </ViewMedium>
            <ViewLarge>
                <ShowArticleCostsButtonRowMedium 
                    articleId={articleId}
                    prices={prices}
                    articles={products}
                />
            </ViewLarge>
        </>
    )
}

export default ShowArticleCostsButtonRow;
